import axios from "axios";
import { apiUrl } from "./apiClient";

/**
 * Claim form endpoints: AI document extraction and status prediction.
 *
 * These use axios (session cookie via axios.defaults.withCredentials, set in
 * utils/authInterceptor.js) and resolve to the axios response; callers read
 * response.data and error.response?.data?.detail as before.
 */

/** POST /extract-warranty-claim - multipart upload of a claim document image. */
export function extractWarrantyClaim(file) {
  const uploadFormData = new FormData();
  uploadFormData.append("file", file);
  return axios.post(apiUrl("/extract-warranty-claim"), uploadFormData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

/** POST /predict-from-json-dmy/ - AI prediction for a claim in the API's JSON shape. */
export const predictClaim = (claim) =>
  axios.post(apiUrl("/predict-from-json-dmy/"), claim, { headers: { "Content-Type": "application/json" } });
